// Promo codes are switched off site-wide.
//
// Two independent reasons, both verified:
//   1. The `coupons` table is empty, so `validate_coupon` rejects every code.
//   2. `cartCreate` is called without `discountCodes` and nothing ever calls
//      `cartDiscountCodesUpdate`, so a discount shown here would disappear at
//      the checkout on furnifindusa.com.
//
// The cart's promo-code input and the validate_coupon / use_coupon RPCs are
// left in place behind this flag. Flip it to true on the day real Shopify
// discount codes exist and are applied to the cart that goes to checkout.
export const PROMO_CODES_ENABLED = false;
